import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { INITIALIZED } from '../core/constants';
import rootSaga from '../sagas';
import apiRequestCounter from './apiRequestCounter';
import queueHandler from './queueHandler';
import rootReducer from './rootReducer';
import { baseApi } from '../core/api/rtk/baseApi';
import { setStore } from './storeRef';

export default function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();

  const store = createReduxStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        thunk: true, // Enable thunk middleware for RTK Query
        serializableCheck: false, // Disable serializable check to avoid warnings with old Redux system
      });

      return [
        ...defaultMiddleware,
        baseApi.middleware,
        apiRequestCounter,
        queueHandler,
        sagaMiddleware,
      ];
    },
    devTools: process.env.NODE_ENV !== 'production',
  });

  // Expose the store to non-React modules (see storeRef) before any saga runs.
  setStore(store);

  sagaMiddleware.run(rootSaga);

  store.dispatch({ type: INITIALIZED });

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      /* eslint-disable */
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
      /* eslint-enable */
    });
  }

  return store;
}
